import { Dialog, Text } from 'braid-design-system';
import { add } from 'date-fns/add';
import { useId } from 'react';

import { Secret } from './Credential/Secret.tsx';

import type { GetPartnerTokenPayload } from '#src/api/index.ts';
import { TwoColumnGrid } from '#src/components/TwoColumnGrid/TwoColumnGrid.tsx';

export const PartnerTokenDialog = ({
  partnerToken,
  onClose,
}: {
  partnerToken: GetPartnerTokenPayload;
  onClose: () => void;
}) => (
  <Dialog
    id={useId()}
    title="Successfully generated partner token"
    open={true}
    onClose={onClose}
  >
    <TwoColumnGrid space="medium">
      <Text size="small" weight="medium">
        Expires at
      </Text>

      <Text size="small">
        {add(new Date(), {
          seconds: partnerToken.expiresIn,
        }).toLocaleString()}
      </Text>
      <Secret label="Partner token" secret={partnerToken.accessToken} />
    </TwoColumnGrid>
  </Dialog>
);
